module.exports = __webpack_public_path__ + "static/torm-symbol-DND3_FnP-470b676a0ddd6a1c3504d0051e3fdf99.png";